import React, { useContext } from 'react'
import getHistory from '../../helpers/getHistory'
import { RowWrapper, RowDiv, RowData, RowTitle } from './elementsStyles'
import { MyContext } from '../../../../context/createContext'
interface Row_props {
  data: any
  prec: number
  requestBetReply: (s: string) => void
  handleRoundId: (s: string) => void
  handlePopup: (s: string) => void
}

export default function Row({
  data,
  requestBetReply,
  handleRoundId,
  handlePopup,
  prec,
}: Row_props) {
  const { context } = useContext(MyContext)
  const { content, win, round_id } = getHistory(data, prec) //TODO get precise

  const clickHandler = (id: string) => {
    handleRoundId(id)
    requestBetReply(id)
    setTimeout(() => {
      handlePopup('Bet Reply')
    }, 167)
  }
  return (
    <RowWrapper
      win={Number(win) > 0}
      onClick={() => clickHandler(round_id.toString())}
    >
      <div className='btn'>
        {content.map((item: any, id: number) => (
          <RowDiv key={id}>
            <RowTitle win={Number(win) > 0}>{item.name}</RowTitle>
            <RowData win={Number(win) > 0}>{item.content}</RowData>
          </RowDiv>
        ))}
      </div>
    </RowWrapper>
  )
}
